// sonner의 toast.success/error/message/info 를 가로채 중앙 축하 토스트(zm-toast)로 라우팅.
// 호출부(toast.success(...) 등) 변경 없이 스타일만 교체. App.js 에서 1회 import.
import { toast } from "sonner";

const toText = (m) => {
  if (typeof m === "string") return m;
  if (m == null) return "";
  try { return String(m); } catch { return ""; }
};

const emit = (type) => (message) => {
  window.dispatchEvent(new CustomEvent("zm-toast", { detail: { type, message: toText(message) } }));
  return Date.now();
};

["success", "error", "message", "info"].forEach((m) => {
  toast[m] = emit(m);
});
